import lemon from "./../sounds/lemon.ogg";
import orange from "./../sounds/orange.ogg";
import banana from "./../sounds/banana.ogg";
import pear from "./../sounds/pear.ogg";
import cherry from "./../sounds/cherry.ogg";
import strawberry from "./../sounds/strawberry.ogg";
import blueberry from "./../sounds/blueberry.ogg";
import apple from "./../sounds/apple.ogg";

export const fruits = [
    {
      title: "banana",
      polish: "banan",
      image:
        "https://images.unsplash.com/photo-1579523360587-1e2613000ee3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        sounds: banana,
    },
    {
      title: "orange",
      polish: "pomarańcza",
      image:
        "https://cdn.pixabay.com/photo/2017/01/20/15/04/orange-1995052_1280.jpg",
        sounds: orange,
    },
    {
      title: "lemon",
      polish: "cytryna",
      image:
        "https://images.unsplash.com/photo-1580412092181-219a7b10e6ce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=650&q=80",
        sounds: lemon,
    },
    {
      title: "pear",
      polish: "gruszka",
      image:
        "https://cdn.pixabay.com/photo/2015/12/09/13/12/peer-1084687_1280.jpg",
        sounds: pear,
    },
    {
      title: "cherry",
      polish: "wiśnia",
      image:
        "https://images.unsplash.com/photo-1528820600606-0ef5600cbfee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
        sounds: cherry,
    },
    {
      title: "strawberry",
      polish: "truskawka",
      image:
        "https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=658&q=80",
        sounds: strawberry,
    },
    {
      title: "blueberry",
      polish: "borówka",
      image:
        "https://images.unsplash.com/photo-1584879135892-53935a4b1408?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80",
        sounds: blueberry,
    },
    {
      title: "apple",
      polish: "jabłko",
      image:
        "https://images.unsplash.com/photo-1590005354167-6da97870c757?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=801&q=80",
        sounds: apple,
    },
  ];
